<template>
    <form
        class="container-fluid"
        @submit.prevent="saveForm"
    >
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-12">
                        <h1 class="page-title" />
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-6">
                        <label>Name</label>
                        <user-select
                            v-model="form.user_id"
                            autoselect
                            disabled
                        />
                        <form-error
                            name="user_id"
                            :errors="errors"
                        />
                    </div>

                    <div class="col-sm-12 col-md-6">
                        <label>Date</label>
                        <date-picker
                            v-model="form.form_date"
                            :options="{format: 'DD/MM/YYYY'}"
                        />
                        <form-error
                            name="form_date"
                            :errors="errors"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-6">
                        <label>Type</label>
                        <select
                            v-model="form.type"
                            class="form-control"
                        >
                            <option>Example</option>
                        </select>
                        <form-error
                            name="type"
                            :errors="errors"
                        />
                    </div>

                    <div class="col-sm-12 col-md-6">
                        <label>Hours</label>
                        <input
                            type="number"
                            step="0.1"
                            min="0"
                            class="form-control"
                            v-model="form.hours"
                        >
                        <form-error
                            name="hours"
                            :errors="errors"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="row mb-2">
                    <div class="col-sm-12">
                        <label>Title</label>
                        <input
                            v-model="form.title"
                            class="form-control"
                        >
                        <form-error
                            name="title"
                            :errors="errors"
                        />
                    </div>
                </div>

                <div class="row mb-2">
                    <div class="col-sm-12">
                        <label>Please describe the activity</label>
                        <textarea
                            v-model="form.description"
                            class="form-control"
                        />
                        <form-error
                            name="description"
                            :errors="errors"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <label>Reflective element</label>
                        <textarea
                            v-model="form.reflective_element"
                            class="form-control"
                        />
                        <form-error
                            name="reflective_element"
                            :errors="errors"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-12">
                        <label for="upload">
                            Please attach and relevant evidence if available
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <input
                            id="upload"
                            type="file"
                            name="upload"
                        >

                        <FormError
                            name="upload"
                            :errors="errors"
                        />
                    </div>
                </div>

                <div
                    class="row mt-4"
                    v-if="form.upload"
                >
                    <div class="col-sm-12">
                        <a
                            :href="form.upload.full_url"
                            target="_blank"
                        >
                            <i class="fas fa-file" />
                            {{ `View ${form.upload.original_filename}` }}
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-12">
                        <button
                            class="btn btn-primary"
                            :disabled="isSaving"
                        >
                            {{ isSaving ? 'Saving' : 'Save Form' }}
                        </button>

                        <button
                            v-if="form.id"
                            type="button"
                            class="btn text-danger"
                            :disabled="isSaving || isLoading"
                            @click.prevent="deleteForm"
                        >
                            Delete Form
                        </button>

                        <router-link
                            type="button"
                            class="btn"
                            :to="{name: 'engineer.cpc-forms.index'}"
                        >
                            Back
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import UserSelect from "../../UserSelectComponent.vue";
import FormError from "../../ErrorComponent.vue";
import DatePicker from "../../DateTimePickerComponent.vue";
import UsesInfoMessage from "../../../mixins/UsesInfoMessage";
import UsesErrors from "../../../mixins/UsesErrors";
import Auth from '../../../mixins/Auth';
import FireAlarmUploadPreview from "../../forms/parts/FireAlarmUploadPreview.vue";

const initialForm = {
    user_id: null,
    form_date: window.moment(),
    type: '',
    hours: '',
    title: '',
    description: '',
    reflective_element: '',
};
export default {
    components: {
        FireAlarmUploadPreview,
        UserSelect,
        FormError,
        DatePicker,
    },
    mixins: [
        UsesInfoMessage,
        UsesErrors,
        Auth,
    ],
    props: {
        id: {
            type: String,
            required: false,
            default: undefined,
        }
    },
    data: function () {
        return {
            form: {
                ...initialForm,
            },
        };
    },
    watch: {
        id: {
            immediate: true,
            handler: async function (newId) {
                this.clearErrors();
                if (document.querySelector('#upload')) {
                    document.querySelector('#upload').value = null;
                }
                if (!newId) {
                    this.form = {...initialForm};
                    return;
                }

                this.setLoading();
                window.axios.get(`/api/cpc-forms/${newId}`)
                    .then(({data}) => {
                        this.form = {
                            ...data,
                            form_date: window.moment(data.form_date),
                        };
                    })
                    .catch(error => {
                        window.alert('Failed to load form');
                        console.error(error)
                        this.$router.replace({name: 'cpc-forms.index'});
                    }).finally(() => {
                        this.clearLoading();
                    })
            }
        }
    },
    methods: {
        saveForm: function () {
            this.setSaving();
            this.clearErrors();

            const formData = new FormData();

            const formObject = {
                ...this.form,
                form_date: this.form.form_date ? this.form.form_date.format('YYYY-MM-DD') : null,
            };

            delete formObject.upload

            Object.keys(formObject).forEach(key => formData.append(key, formObject[key]));

            var uploadFile = document.querySelector('#upload');
            if (uploadFile.files[0]) {
                formData.append('upload', uploadFile.files[0]);
            }

            if (!this.form.id) {
                window.axios.post(`/api/cpc-forms`, formData)
                    .then(({data}) => {
                        window.alert('Form saved successfully');
                        this.$router.push({name: 'engineer.cpc-forms.edit', params: {id: data.id}});
                    })
                    .catch(this.captureRequestErrors)
                    .finally(() => this.clearSaving())
                return;
            }

            window.axios.post(`/api/cpc-forms/${this.id}?_method=PUT`, formData)
                .then(({data}) => {
                    window.alert('Form saved successfully');
                })
                .catch(this.captureRequestErrors)
                .finally(() => this.clearSaving())
        },

        deleteForm: function () {
            const confirm = window.confirm('Are you sure you want to delete this form?');

            if (!confirm) {
                return;
            }

            this.setLoading(true);

            window.axios.delete(`/api/cpc-forms/${this.id}`)
                .then(() => {
                    window.alert('Form deleted successfully');

                    window.setTimeout(() => {
                        this.clearLoading();
                        this.$router.push({name: 'engineer.cpc-forms.index'});
                    }, 3000);
                }).catch(() => {

                    this.setErrorMessage('Something went wrong');
                    this.clearLoading();
                })
        }
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/engineer/cpc-forms/FormComponent.vue